import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// Usage: <PrivateRoute allowedRoles={["superadmin"]}><Component /></PrivateRoute>
const PrivateRoute = ({ children, allowedRoles }) => {
  const isAuthenticated = localStorage.getItem("auth") === "true";
  const userRole = localStorage.getItem("role");
  const checkRole = localStorage.getItem("checkRole");
  const location = useLocation();

  console.log("checkRole",checkRole);
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // if (allowedRoles && !allowedRoles.includes(userRole)) {
  //   return <Navigate to="/unauthorized" replace />;
  // }

  if (allowedRoles && !allowedRoles.includes(checkRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children; 
};

export default PrivateRoute;